import { useRef, useState , useEffect, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";

import ymsg from "../../ymsg.png";
import empty_user from "../../empty_user.png";


function ChatList(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [tab, setTab] = useState(null);

    const [itemSelected, setItemSelected] = useState(1);

    const [fraza,setFraza] = useState("");



    const clickTab = (e) => {

        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);
    }


    const onSearch= (e) => {
        var x = e.target.value;

        x = x.toLowerCase();

        setFraza(x);
    }

    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_msg,chat_list', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const openChat = (e) => {
      
        var typ = e.currentTarget.getAttribute('typ');
        var typId = e.currentTarget.getAttribute('typId');        
        var title = e.currentTarget.getAttribute('title');        
        props.mainView.openChat(title, typ, typId);
    }


    if(tab == null)
        {
            setTab([]);
            getTab();
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
            {         
                setRefreshView( props.userData.refreshView);
                setTab(null);                
            }
        

    if(tab.opiekunowie == null)
    {
        return <div>...</div>
    }



    var cssTab1 = "";
    var cssTab2 = "";
    var cssTab3 = "";
    var cssTab4 = "";

    if(itemSelected == 1) cssTab1 = " xActive ";
    if(itemSelected == 2) cssTab2 = " xActive ";
    if(itemSelected == 3) cssTab3 = " xActive ";
    if(itemSelected == 4) cssTab4 = " xActive ";

    return <div className="view_content">

                          


                <div className="big_search">
                      <input type="text" value={fraza} onChange={onSearch} placeholder="Szukaj: " />
                </div>        

                <div className="xTabs">
                        <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Wszyscy</div>
                        <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab} >Grupy</div>
                        <div className={"xItem " + cssTab3 } atr-tab="3" onClick={clickTab} >Kadra</div>                  
                        <div className={"xEmpty "  }>&nbsp;</div>
                </div>


  
               
                            <table className="contact">
                               
                                {
                                     (itemSelected ==1  || itemSelected == 3) &&

                                      tab.opiekunowie.map( (row, ix )  => {

                                        var filter = true;


                                        if(fraza.length > 2)
                                        {
                                            filter = false;
                                           

                                            var c1 = row.nazwisko.toLowerCase();
                                            var c2 = row.imie.toLowerCase();

                                            if(c1.includes(fraza) || c2.includes(fraza) ) filter = true;

                                            

                                        }


                                        if(filter == false) return null;


                                        var ostD = "";
                                        if(row.ostatnia_aktywnosc.length > 3)
                                        {
                                            ostD = "Aktywny: " + row.ostatnia_aktywnosc;
                                        }

                                        var aw = empty_user;
                                                                                    
                                        if(row.awatar.length > 10)
                                        {
                                                aw = "data:image/png;base64," + row.awatar;
                                        }


                                        return <tr typ="px_group" typId={row.id} title={row.nazwisko + " " + row.imie} onClick={openChat}>
                                                    <td className="c_awatar"><img src={aw} /></td>
                                                    <td className="c_name">{row.nazwisko + " " + row.imie}</td>
                                                    <td className="c_type">Kadra</td>
                                                    <td className="c_date">{ostD}</td>
                                            </tr>

                                      })

                                }
                             

                            </table>                  

                            {
                                (itemSelected == 1 || itemSelected == 2) &&
                                <Fragment>
                                            {
                                                tab.grupy.map( (row, ix) => {

                                                return <div>
                                                                <h2>{row.nazwa} </h2>
                                                                
                                                              
                                                                <table className="contact">
                                                                {
                                                                    row.dzieci.map( (dz, dix) => {

                                                                            return <Fragment>
                                                                                
                                                                                    {
                                                                                        dz.rodzice.map(  (rdz, rix) => {


                                                                                            var filter = true;


                                                                                            if(fraza.length > 2)
                                                                                            {
                                                                                                filter = false;
                                                                                               
                                                    
                                                                                                var c1 = rdz.nazwisko.toLowerCase();
                                                                                                var c2 = rdz.imie.toLowerCase();
                                                    
                                                                                                if(c1.includes(fraza) || c2.includes(fraza) ) filter = true;
                                                    
                                                                                                
                                                    
                                                                                            }
                                                    
                                                    
                                                                                            if(filter == false) return null;


                                                                                            var aw = empty_user;
                                                                                    
                                                                                            if(rdz.awatar.length > 10)
                                                                                            {
                                                                                                aw = "data:image/png;base64," + rdz.awatar;
                                                                                            }


                                                                                            return <tr  typ="px_group" typId={rdz.id} title={rdz.nazwisko + " " + rdz.imie} onClick={openChat}>
                                                                                            <td className="c_awatar"><img src={aw} /></td>
                                                                                            <td className="c_name">{rdz.nazwisko + " " + rdz.imie}</td>
                                                                                            <td className="c_type">Rodzic (Dziecko: {dz.dziecko})</td>
                                                                                            <td className="c_date">{rdz.ostatnia_aktywnosc}</td>
                                                                                            </tr>

 

                                                                                        } )
                                                                                    }

                                                                            </Fragment>

                                                                    } ) 

                                                                }
                                                                </table>
                                                </div>

                                                } )
                                            }
                                </Fragment>
                            }        
              




    </div>




    if( 1==2 )
    return (

           <div className="view_content"  >
                <h2><PlTitle userData={props.userData} /> / Kadra</h2>
                <br/>

                <div className="chats">

                      
                        {
                            tab.opiekunowie.map( (row, ix )  => {

                               return   <div className="chat_item"  typ="px_group" typId={row.id} title={row.nazwisko + " " + row.imie} onClick={openChat} >
                                            <img src={empty_user} />
                                            <div className="chat_person" >{row.nazwisko} {row.imie}</div>
                                        </div> 

                            })

                        }
        


                </div>

                <div className="chats">
                {
                        tab.grupy.map( (row, ix) => {

                            return <div>
                                            <h2><PlTitle userData={props.userData} /> / Chat-y / {row.nazwa} </h2>
                                            <br/>

                                            {
                                                row.dzieci.length == 0 &&
                                                <div>
                                                    ....
                                                </div>
                                            }

                                            {
                                                row.dzieci.map( (dz, dix) => {

                                                        return <Fragment>
                                                            
                                                                {
                                                                    dz.rodzice.map(  (rdz, rix) => {

                                                                        var aw = empty_user;
                                                                
                                                                        if(rdz.awatar.length > 10)
                                                                        {
                                                                            aw = "data:image/png;base64," + rdz.awatar;
                                                                        }

                                                                        return   <div className="chat_item"  typ="px_group" typId={rdz.id} title={rdz.nazwisko + " " + rdz.imie} onClick={openChat}>
                                                                                <img src={aw} />
                                                                                <div className="chat_person">{rdz.nazwisko} {rdz.imie}</div>
                                                                                <div className="chat_kids">({dz.dziecko})</div>
                                                                            </div> 

                                                                    } )
                                                                }

                                                        </Fragment>

                                                } ) 

                                            }
                            </div>

                        } )

                }
                </div>

             


            </div>
    )
}



export default ChatList;